import site from './site'
import template from './template'

export default {
  name: 'Site',
  path: 'site',
  meta: {
    label: 'site',
    auth: 'site'
  },
  component: {
    name: 'Site',
    render(c) {
      return c('router-view')
    }
  },
  children: [site, template]
}
